(() => {
  let isMonitoring = false;

  function initSlider() {
    const swiperOptions = {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 12,
    };
    const swiperElement = document.querySelector('.free-samples__slider.swiper');
    if (!swiperElement || swiperElement.dataset.isLoaded == 'true') return;
    const swiper = new Swiper(swiperElement, swiperOptions);
    swiper.on('slideChange', function () {
      const currentIndex = this.activeIndex + 1;
      handleSampleNavigation(currentIndex);
    });
    swiperElement.setAttribute('data-is-loaded', true);
  }

  const sectionsToRender = [
    {
      section_id: 'cart-drawer',
      selectors: ['.drawer__header', 'cart-drawer-items', '.drawer__footer'],
    },
    {
      section_id: 'cart-icon-bubble',
      selectors: ['.cart-count-bubble'],
    },
  ];

  async function updateLiveContent(updatedSections) {
    try {
      for (const section of sectionsToRender) {
        const content = updatedSections[section.section_id];
        const html = new DOMParser().parseFromString(content, 'text/html');
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
  async function fetchCart() {
    try {
      const response = await fetch(routes.cart_url, fetchConfig());
      const data = await response.json();
      return data;
    } catch (e) {
      console.error(e);
      throw new Error('Error fetching cart');
    }
  }
  async function cartAddItem(variantId, quantity, properties = {}) {
    try {
      const body = JSON.stringify({
        items: [{ id: variantId, quantity, properties }],
        sections: sectionsToRender.map((section) => section.section_id),
      });
      const response = await fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } });
      const data = await response.json();
      await updateLiveContent(data.sections);
    } catch (e) {
      console.error(e);
    }
  }
  async function cartRemoveItem(variantId) {
    try {
      const body = JSON.stringify({
        id: variantId.toString(),
        quantity: '0',
        sections: sectionsToRender.map((section) => section.section_id),
      });
      const response = await fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } });
      const data = await response.json();
      await updateLiveContent(data.sections);
    } catch (e) {
      console.error(e);
    }
  }

  async function buldAddFreeGift(variants, properties = {}) {
    try {
      const body = JSON.stringify({
        items: variants.map((variant_id) => ({
          id: variant_id,
          quantity: 1,
          properties: { _free_item_type: 'Free Gift', ...properties },
        })),
        sections: sectionsToRender.map((section) => section.section_id),
      });
      const response = await fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } });
      const data = await response.json();
      await updateLiveContent(data.sections);
    } catch (e) {
      console.error(e);
    }
  }

  async function bulkRemoveFromCart(variants) {
    try {
      const updates = {};
      variants.forEach((variantId) => {
        updates[variantId] = 0;
      });
      const body = JSON.stringify({
        updates,
        sections: sectionsToRender.map((section) => section.section_id),
      });
      const response = await fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } });
      const data = await response.json();
      await updateLiveContent(data.sections);
    } catch (e) {
      console.error(e);
    }
  }

  function handleSampleNavigation(index) {
    const slider = document.querySelector('.free-samples__slider');
    const total_slides = slider.querySelectorAll('.free-samples__slide').length;
    const current_index = parseInt(slider.dataset.currentIndex);
    let next_index = null;
    if (index === 'next') {
      next_index = current_index + 1;
      const nextSlide = slider.querySelector(`.free-samples__slide[data-slider-index="${next_index}"]`);
      if (!nextSlide) return;
      slider.setAttribute('data-current-index', next_index);
    } else if (index == 'prev') {
      next_index = current_index - 1;
      const prevSlide = slider.querySelector(`.free-samples__slide[data-slider-index="${next_index}"]`);
      if (prevSlide) {
        slider.setAttribute('data-current-index', next_index);
      }
    } else {
      next_index = index;
      const slide = slider.querySelector(`.free-samples__slide[data-slider-index="${index}"]`);
      if (slide) {
        slider.setAttribute('data-current-index', index);
      }
    }
    // update the navigation buttons
    const prevButton = document.querySelector('.free-samples__container .navigation_arrows .--arrow_prev');
    const nextButton = document.querySelector('.free-samples__container .navigation_arrows .--arrow_next');
    if (next_index == 1) {
      prevButton.setAttribute('disabled', 'disabled');
    } else {
      prevButton.removeAttribute('disabled');
    }
    if (next_index == total_slides) {
      nextButton.setAttribute('disabled', 'disabled');
    } else {
      nextButton.removeAttribute('disabled');
    }

    // update dots
    const dots = document.querySelectorAll('.free-samples__container .control__dot');
    dots.forEach((dot) => {
      const dotIndex = parseInt(dot.dataset.dotIndex);
      if (dotIndex == next_index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    // upadte pagination
    const currentPage = document.querySelector('.free-samples__container .current_page');
    currentPage.textContent = next_index;
    // console.log({ index, next_index, current_index, total_slides });

    const swiper = document.querySelector('.free-samples__slider.swiper').swiper;
    if (swiper) {
      if (index === 'next') {
        swiper.slideNext();
      } else if (index === 'prev') {
        swiper.slidePrev();
      } else {
        swiper.slideTo(index - 1);
      }
    }
  }

  function toggleExpandedFreeSample() {
    const container = document.querySelector('#component-cart-free-samples--container');
    container.querySelector('.free-samples__container').classList.toggle('--collapsed');
  }

  async function monitorFreeItemsThreshold() {
    async function delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    // console.log('[CUSTOM BOGO WIDGET] Monitoring Free Samples Thershold');
    try {
      if (isMonitoring) return;

      isMonitoring = true;

      await delay(1000);

      // Get cart object from local storage (handled by cart-watcher.js)
      const cartRaw = await fetchCart();

      if (!cartRaw) {
        console.error('Cart not found');
        return;
      }

      // Get real cart items, excluding strikethrough items
      const realCartItems =
        cartRaw?.items?.filter(
          (item) => !item.properties.hasOwnProperty('_strikethrough') && !item.properties.hasOwnProperty('_gwp_promo')
        ) ?? [];

      // Calculate real total price
      const realTotalPrice = realCartItems.reduce((acc, item) => {
        return acc + item.final_line_price;
      }, 0);

      // Create a new cart object with real items and total price
      const cartWithoutStrikethrowAndFreeItems = { ...cartRaw, items: realCartItems, total_price: realTotalPrice };

      if (!cartWithoutStrikethrowAndFreeItems) return;

      /* @ FREE SAMPLES LOGIC */
      // Get free samples threshold
      const thresholdTag = document.querySelector('[data-free-samples-thershold]');
      const freeSamplesWidgetThreshold = parseInt(thresholdTag.dataset.freeSamplesThershold);
      // Get free samples in cart
      const freeSamples = cartWithoutStrikethrowAndFreeItems.items.filter(
        (item) => item.properties._free_item_type === 'Free Sample'
      );
      // ACTION: Remove Free Samples from cart if there are free samples in cart and total price is less than threshold
      if (freeSamples.length && cartWithoutStrikethrowAndFreeItems.total_price < freeSamplesWidgetThreshold) {
        // debugger;
        const freeSamplesVariants = freeSamples.map((item) => item.variant_id);
        await bulkRemoveFromCart(freeSamplesVariants);
      }

      /* @ FREE GIFT LOGIC */
      const gwpPromos = getFreeGiftPromos() ?? null;
      if (!gwpPromos) return;

      // debugger;
      for (const gwpPromo of gwpPromos) {
        // Should add automatically to the cart?
        let gwpAutoAdd = gwpPromo?.automatically_add_to_cart ?? false;

        // Check if UTM Target is set and if it's different from the current UTM Target
        if (gwpPromo?.utm_target && gwpPromo.automatically_add_to_cart) {
          gwpAutoAdd = false;
          const urlParams = new URLSearchParams(window.location.search);
          const storedUtmTarget = localStorage.getItem('gwp_utm_target')
            ? JSON.parse(localStorage.getItem('gwp_utm_target'))
            : null;
          const currentUtmTarget = urlParams.get('utm_content');
          if (
            currentUtmTarget?.toLowerCase() === gwpPromo.utm_target?.toLowerCase() ||
            storedUtmTarget?.find((t) => t.toLowerCase() === gwpPromo.utm_target?.toLowerCase())
          ) {
            gwpAutoAdd = true;
          }
        }
        // Get free gift promo threshold
        const freeGiftThreshold = gwpPromo?.cart_threshold ?? null;
        // Get free gift variants in cart
        const freeGiftVariantsInCart = cartRaw.items
          .filter((item) => item.properties['_gwp_promo'] == gwpPromo.promo_handle)
          .map((item) => item.variant_id);
        // Get other items in cart
        const otherItemsInCart = cartWithoutStrikethrowAndFreeItems.items.filter(
          (item) => !item.properties['_gwp_promo']
        );

        // debugger;
        if (
          // ACTION: Remove FreeGifts if there are free gift variants in cart and total price is less than threshold
          !otherItemsInCart ||
          (otherItemsInCart.length == 0 && freeGiftVariantsInCart.length > 0) ||
          (freeGiftThreshold != null && cartWithoutStrikethrowAndFreeItems.total_price < freeGiftThreshold)
        ) {
          await bulkRemoveFromCart(freeGiftVariantsInCart);
        } else if (
          // ACTION: Add FreeGifts if there are no free gift variants in cart and total price is greater than threshold
          gwpAutoAdd &&
          freeGiftThreshold != null &&
          cartWithoutStrikethrowAndFreeItems.total_price >= freeGiftThreshold &&
          cartWithoutStrikethrowAndFreeItems.items.length > 0
        ) {
          // Get Free Gift variants that are still not added to cart
          const freeGiftVariants = gwpPromo?.gwp_products?.map((variant) => variant.id);
          const variantsToAdd = freeGiftVariants?.filter((variant) => !freeGiftVariantsInCart.includes(variant));
          if (!variantsToAdd || variantsToAdd.length == 0) continue;
          // Add Free Gift variants to cart and include _gwp_promo property with promo name
          const promoHandle = gwpPromo.promo_handle;
          await buldAddFreeGift(variantsToAdd, { _gwp_promo: promoHandle });
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      isMonitoring = false;
    }
  }
  async function monitorUnavailableItems() {
    try {
      // Get a list of unavailable Samples and Gifts in the cart and remove it
      const dataElement = document.querySelector('#freeItemsToRemove');
      const variants_to_remove = JSON.parse(dataElement.textContent);
      if (!variants_to_remove || variants_to_remove.length == 0) return false;
      // Remove unavailable items from cart
      await bulkRemoveFromCart(variants_to_remove);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  // This function will handle clicks on the widget Items for action Add/Remove
  async function handleSampleWidgetClick(e) {
    const container = e.currentTarget.closest('#component-cart-free-samples--container');
    try {
      container.classList.add('--blocked');
      const variantId = e.currentTarget.dataset?.variantId;
      const isSelected = e.currentTarget.classList.contains('--selected');

      const promoType = e.currentTarget.dataset?.promoType ?? null;
      const promoDisplayName = e.currentTarget.dataset?.promoDisplayName ?? '';

      if (!promoType || typeof promoType !== 'string') throw new Error('Promo Type not defined or not string');

      const properties = {
        _free_item_type: promoDisplayName,
      };

      if (promoType === 'free-gift') {
        const promoHandle = e.currentTarget.dataset.promoHandle;
        properties['_gwp_promo'] = promoHandle;
      }

      if (isSelected) {
        // If already selected and is clicked, then action will be to REMOVE From Cart
        await cartRemoveItem(variantId);
      } else {
        // If not selected and is clicked, then action will be to ADD To Cart
        await cartAddItem(variantId, 1, properties);
      }
    } catch (err) {
      console.error(err);
    }
  }

  window.toggleExpandedFreeSample = toggleExpandedFreeSample;
  window.handleSampleWidgetClick = handleSampleWidgetClick;
  window.handleSampleNavigation = handleSampleNavigation;

  window.addEventListener('cart_changed', async (e) => {
    // Listen for cart changes, filter out strikethrough items and monitor free samples thershold
    const addedChanges = e?.detail?.changes?.added?.filter(
      (item) => !item.properties.hasOwnProperty('_strikethrough') || item.properties.hasOwnProperty('_gwp_promo')
    );
    const removedChanges = e?.detail?.changes?.removed?.filter(
      (item) => !item.properties.hasOwnProperty('_strikethrough') || item.properties.hasOwnProperty('_gwp_promo')
    );
    const realChanges = [...addedChanges, ...removedChanges];
    if (!realChanges || realChanges.length == 0) return;
    await monitorFreeItemsThreshold();
    // Initialize free samples slider after 1 second
    setTimeout(() => {
      initSlider();
    }, 1000);
  });
  window.addEventListener('DOMContentLoaded', async () => {
    if (!(await monitorUnavailableItems())) initSlider();
  });
})();
